import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          {/* Company Information */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              Sampanna Sanchar<span>.</span>
            </Link>

            <p>
              Creating meaningful visual stories through video production and
              multimedia solutions.
            </p>
          </div>

          {/* Contact Information */}
          <div className="footer-contact">
            <h4>Get in Touch</h4>

            <a
              href="https://www.google.com/maps/search/?api=1&query=New+Baneshwor+Kathmandu+Nepal"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-item"
            >
              <MdLocationOn aria-hidden="true" />
              <span>New Baneshwor, Kathmandu, Nepal</span>
            </a>

            <a href="tel:+97711234567" className="footer-contact-item">
              <MdPhone aria-hidden="true" />
              <span>+977-1-1234567</span>
            </a>

            <a
              href="mailto:contact@sampannasanchar.com.np"
              className="footer-contact-item"
            >
              <MdEmail aria-hidden="true" />
              <span>contact@sampannasanchar.com.np</span>
            </a>
          </div>

          {/* Social Media */}
          <div className="footer-social">
            <h4>Find Us On</h4>

            <p>Follow our work and latest updates.</p>

            <div className="social-links-horizontal">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Sampanna Sanchar on Facebook"
                className="social-icon facebook"
              >
                <FaFacebook aria-hidden="true" />
              </a>

              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Sampanna Sanchar on YouTube"
                className="social-icon youtube"
              >
                <FaYoutube aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Sampanna Sanchar Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
